import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "Microsoft 365",
  published_at: "2026-03-02",
  summary: "Connect your Microsoft account and let the AI assistant manage email, documents, presentations, meetings, and Teams messages.",
  tags: ["Integrations"],
  draft: false
};
export const sections = [{
  id: "manage-in-settings",
  label: "Manage in Settings"
}];
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Sweetspot now connects to Microsoft 365. Link your Microsoft account and the AI assistant can work across your entire Office suite — read and send emails in Outlook, schedule meetings on your calendar, and search your organization's directory. GCC and GCC High cloud environments are also supported for organizations that require those deployments. No more switching between tabs to draft a follow-up email or check your schedule before committing to a deadline."
    }), "\n", _jsx(_components.h3, {
      children: "Email"
    }), "\n", _jsx(_components.p, {
      children: "Draft, review, and send Outlook emails directly from the assistant, with your thread context and timing handled in one flow."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "0e4248fd-64c4-598c-a656-14287ca5d408"
    }), "\n", _jsx(_components.h3, {
      children: "Word"
    }), "\n", _jsx(_components.p, {
      children: "Create and edit Word documents with proper styles and structure, including drafts like teaming agreements and internal memos."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "a33cace6-120f-58f7-8113-f731c29ff4f8"
    }), "\n", _jsx(_components.h3, {
      children: "PowerPoint"
    }), "\n", _jsx(_components.p, {
      children: "Generate presentation decks from your latest opportunity context and quickly iterate slide content before sharing."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "d513a82a-7327-5033-889f-d9ef9dde07d1"
    }), "\n", _jsx(_components.p, {
      children: "The assistant can also browse files in OneDrive and SharePoint, and send Teams messages to your colleagues when you need to coordinate quickly."
    }), "\n", _jsx(_components.h2, {
      id: "manage-in-settings",
      tabIndex: "-1",
      children: "Manage in Settings"
    }), "\n", _jsx(_components.p, {
      children: "You can manage Microsoft 365 in Settings under Integrations. From there, your team can configure credential mode, cloud environment support (Commercial, GCC, and GCC High), and enabled toolsets."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/changelog/2026-03-02-microsoft-365/settings-integrations.png",
        alt: "Microsoft 365 integration settings in the Integrations tab"
      })
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Shred (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Archive actions for organizing analyzed documents"
        }), "\n", _jsx(_components.li, {
          children: "Requirements are now accessible from the Shred sidebar"
        }), "\n", _jsx(_components.li, {
          children: "Fixed knowledge base and compliance checklist permissions not applying correctly in some cases"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "UX (3)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Redesigned dropdown menus across the platform for a cleaner look"
        }), "\n", _jsx(_components.li, {
          children: "Larger text display for opportunity details"
        }), "\n", _jsx(_components.li, {
          children: "Fixed company information not refreshing after edits"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Performance (1)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Much faster and more reliable AI chat sessions with support for longer running conversations"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "General (1)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Microsoft admin consent flow for organization-wide setup"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
